<ng-container *ngIf="hasValue; else inapplicable"><span *ngIf="!hideValue">{{value}}</span></ng-container>
<ng-template #inapplicable>
  <span [ngbTooltip]="'ui.inapplicable-info'|translate">
    <span class="hover-tooltip">{{'ui.inapplicable'|translate}}</span>
  </span>
</ng-template>
